// extracted by mini-css-extract-plugin
module.exports = {"cont":"MomentHeader_cont__1uW9_","mainText":"MomentHeader_mainText__ctrUD","subText":"MomentHeader_subText__-ARiu"};